import React from 'react';
import { getImageUrl, getThumbnailUrl } from '../../utils/api';
import { useLanguage } from '../../contexts/LanguageContext';

const DressDisplay = ({ 
  dress, 
  showImage = true, 
  showBrand = true,
  showStockCount = false,
  onImageClick,
  className = '',
  imageClassName = 'table-preview-image',
  placeholderIcon = '👗',
  useThumbnail = true
}) => {
  const { t } = useLanguage();
  const handleImageClick = () => {
    if (onImageClick && dress.images && dress.images.length > 0) {
      onImageClick(dress);
    }
  };

  return (
    <div className={`dress-display ${className}`}>
      {showImage && (
        <div className="dress-image-container">
          {dress.images && dress.images.length > 0 ? (
            <img 
              src={useThumbnail ? getThumbnailUrl(dress.images[0]) : getImageUrl(dress.images[0])}
              alt={dress.name}
              className={`${imageClassName} ${onImageClick ? 'clickable' : ''}`}
              onClick={handleImageClick}
              title={onImageClick ? t('common.tooltips.viewAllImages') : dress.name}
            />
          ) : (
            <div className={`${imageClassName}-placeholder`}>
              <span className={`${imageClassName}-placeholder-icon`}>{placeholderIcon}</span>
            </div>
          )}
        </div>
      )}
      <div className="dress-text-container">
        <div className="dress-name">{dress.name}</div>
        {showBrand && dress.brand_name && (
          <div className="dress-brand">{dress.brand_name}</div>
        )}
        {showStockCount && dress.stock_count !== undefined && (
          <div className="dress-stock">
            {t('dresses.stockCount')}: {dress.stock_count === 0 ? (
              <span className="stock-count zero">{dress.stock_count}</span>
            ) : (
              <span className="stock-value">{dress.stock_count}</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DressDisplay;
